module.exports = __webpack_public_path__ + "img/communication.d6652523.png";